import React from "react";
import { isPricingRedesignEnabled } from "../../../../featureToggles";
import { PriceListLegacy } from "./PriceListLegacy";
import { PriceListModern } from "./PriceListModern";

export const PriceList = (props) => {
    if (isPricingRedesignEnabled) {
        return <PriceListModern {...props} />;
    }

    return <PriceListLegacy {...props} />;
};
